// Copied from https://github.com/stimulus-components/stimulus-reveal-controller/blob/master/src/index.ts

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "icon"];
  static classes = ["hidden"];

  connect() {
    this.class = this.hasHiddenClass ? this.hiddenClass : "hidden";
  }

  toggle() {
    this.itemTargets.forEach((item) => {
      item.classList.toggle(this.class);
    });

    // Rotate icon if present
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-90");
    }
  }

  show() {
    this.itemTargets.forEach((item) => {
      item.classList.remove(this.class);
    });

    // Rotate icon to down position if present
    if (this.hasIconTarget) {
      this.iconTarget.classList.add("rotate-90");
    }
  }

  hide() {
    this.itemTargets.forEach((item) => {
      item.classList.add(this.class);
    });

    // Rotate icon to right position if present
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove("rotate-90");
    }
  }
}
